import React, { useState, useEffect } from 'react'
import { BsFillCloudUploadFill } from 'react-icons/bs';
import { MdDelete, MdError } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

import { client } from '../client';
import Spinner from './Spinner';
import { searchCodeTableQuery } from '../utils/data';


const CreatePrompt = ({ user }) => {
  const [title, setTitle] = useState('');
  const [type, setType] = useState();
  const [line, setLine] = useState('');
  const [instruction, setInstruction] = useState('');
  const [category, setCategory] = useState();
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [fields, setFields] = useState();
  const [imageAsset, setImageAsset] = useState();
  const [wrongImageType, setWrongImageType] = useState(false);
  const [isClauseAgreeable, setIsClauseAgreeable] = useState(false);
  const [cat, setCat] = useState();
  const [aiArt, setAiArt] = useState();

  const navigate = useNavigate();

  useEffect(() => {

    const categoryQuery = searchCodeTableQuery("Category");
    const aiArtGenQuery = searchCodeTableQuery("AiArtGen");
    
      client.fetch(categoryQuery)
      .then((data) => {
        setCat(data);
      })

      client.fetch(aiArtGenQuery)
      .then((data) => {
        setAiArt(data);
      })

}, []);

  const uploadImage = (e) => {
    const selectedFile = e.target.files[0];
    // uploading asset to sanity

      if  ((selectedFile.size <= 5000000) && (selectedFile.type === 'image/png' || selectedFile.type === 'image/svg' || selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/gif' || selectedFile.type === 'image/tiff')) {
        setWrongImageType(false);
        setLoading(true);
        client.assets
          .upload('image', selectedFile, { contentType: selectedFile.type, filename: selectedFile.name })
          .then((document) => {
            setImageAsset(document);
            setLoading(false);
            setStatus('Pending-Review');
          })
          .catch((error) => {
            // console.log('Upload failed:', error.message);
          });
          } else {
            setLoading(false);
            setWrongImageType(true);
            
          }

        };


  const savePrompt = () => {
    if (title && type && line && instruction && imageAsset?._id && category && status && isClauseAgreeable) {
      const doc = {
        _type: 'prompt',
        title,
        type,
        line,
        instruction,
        image: {
          _type: 'image',
          asset: {
            _type: 'reference',
            _ref: imageAsset?._id,
          },
        },
        userId: user._id,
        postedBy: {
          _type: 'postedBy',
          _ref: user._id,
        },
        category,
        status,
        isClauseAgreeable
      };
      client.create(doc).then(() => {
        navigate('/');
      });
    } else {
      setFields(true);

      setTimeout(
        () => {
          setFields(false);
        },
        5000,
      );
    }
  };


  const handleChange = event => {
    if (event.target.checked) {
      // console.log({isClauseAgreeable});
    } else {     
      // console.log({isClauseAgreeable});
    }

    setIsClauseAgreeable(current => !current);
  };

  return (
    <div className="flex flex-col justify-center items-center lg:h-4/5">
      {fields && (
        <div className="alert alert-warning shadow-lg mb-5">
        <div>
          <MdError/>
          <span>Please fill in all the fields</span>
        </div>
      </div>

      )}
      {wrongImageType && (
        <div className="alert alert-warning shadow-lg mb-5">
        <div>
          <MdError/>
          <span>Please only upload files with the following format: JPG, JPEG, SVG, PNG, GIF or TIFF less than 5MB</span>
        </div>
      </div>

      )}
      <div className=" flex lg:flex-row flex-col justify-center items-center bg-white lg:p-5 p-3 w-full">
        <div className="bg-gray-100 p-3 flex flex-0.7 w-full">
          <div className=" flex justify-center items-center flex-col border-2 border-dotted border-gray-300 p-3 w-full h-420">
            {loading && (
              <Spinner />
            )}
            
            {!imageAsset ? (
              // eslint-disable-next-line jsx-a11y/label-has-associated-control
              <label>
                <div className="flex flex-col items-center justify-center h-full">
                  <div className="flex flex-col justify-center items-center">
                    <p className="font-bold text-2xl">
                      <BsFillCloudUploadFill size='100px' />
                    </p>
                    <p className="block uppercase tracking-wide text-gray-700 text-lg font-bold mb-2">Click to upload</p>
                  </div>

                  <p className="mt-10 block normal-case tracking-wide text-gray-700 text-xs mb-2">
                    Recommendation: Upload image with JPG, JPEG, SVG, PNG, GIF or TIFF extensions less than 5MB
                  </p>
                </div>
                <input
                  type="file"
                  name="upload-image"
                  onChange={uploadImage}
                  className="w-0 h-0"
                />
              </label>
            ) : (
              <div className="relative h-full">
                <img
                  src={imageAsset?.url}
                  alt="uploaded-pic"
                  className="h-full w-full"
                />
                <button
                  type="button"
                  className="absolute bottom-3 right-3 p-3 rounded-full bg-white text-xl cursor-pointer outline-none hover:shadow-md transition-all duration-500 ease-in-out"
                  onClick={() => setImageAsset(null)}
                >
                  <MdDelete />
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-1 flex-col gap-6 lg:pl-5 mt-5 w-full">

        <form class="w-full">

        <div className="form-control w-full mb-6">
          <label className="label">
            <span className="label-text">Title</span>
          </label>
          <input type="text" className="input input-bordered w-full" value={title} onChange={(e) => setTitle(e.target.value)} />
        </div>

        <div className="form-control w-full mb-6">
          <label className="label">
            <span className="label-text">Prompt</span>
          </label>
          <input type="text" className="input input-bordered w-full" value={line} onChange={(e) => setLine(e.target.value)}/>
        </div>

        <div className="form-control mb-6">
          <label className="label">
            <span className="label-text">Instruction (How to use?)</span>
          </label> 
          <textarea className="textarea textarea-bordered h-24" value={instruction} onChange={(e) => setInstruction(e.target.value)}></textarea>
        </div>
        
        <div class="flex flex-wrap">
          <div className="form-control w-full md:w-1/2 md:mb-0">
            <label className="label">
              <span className="label-text">AI Art Generator</span>
            </label>
            <select className="select select-bordered" onChange={(e) => {setType(e.target.value);}}>
              <option disabled selected>Pick one</option>
              {aiArt && aiArt.map((item) => (
                    <option value={item.name}>
                      {item.name}
                    </option>
                  ))}
            </select>
          </div>

          <div className="form-control w-full md:w-1/2 md:mb-0">
            <label className="label">
              <span className="label-text">Category</span>
            </label>
            <select className="select select-bordered" onChange={(e) => {setCategory(e.target.value);}}>
              <option disabled selected>Pick one</option>
              {cat && cat.map((item) => (
                    <option value={item.name}>
                      {item.name}
                    </option>
                  ))}
            </select>
          </div>
          
          <div className="form-control mt-5">
            <label className="label cursor-pointer flex gap-2">
              <input type="checkbox" className="checkbox" value={isClauseAgreeable} onChange={handleChange}/>
              <span className="label-text"> I agree that PromptHaven grants the public an irrevocable, nonexclusive, worldwide copyright license to download, copy, modify, 
              distribute, perform, and use my photos or my prompt details that I submit for free, including for commercial purposes, without permission from or attributing me. </span> 
            </label>
          </div>

        </div>

</form>
          <div className="flex flex-col">
              <button type="button"
                onClick={savePrompt} 
                className="btn btn-primary rounded-full">
                  Create Prompt
              </button>
          </div>
        </div>
      </div>
    </div>
  );
};

/*

For user profile image and name
{user && (
            <div className="flex gap-2 mt-2 mb-2 items-center bg-white rounded-lg ">
              <img
                src={user.image}
                className="w-10 h-10 rounded-full"
                alt="user-profile"
              />
              <p className="font-bold">{user.userName}</p>
            </div>
          )}

          
  <div class="flex mt-10">
    <label class="flex items-center gap-2">
      <input class="bg-gray-500 border-gray-300 h-5 w-5 rounded" type="checkbox" />
      <span class="text-xs title-font text-gray-500 tracking-widest uppercase mb-2">I agree to the <span class="underline">privacy policy</span></span>
    </label>
  </div>


  <div class="flex flex-wrap -mx-3 mb-6">
    <div class="w-full px-3">
      <label class="text-xs title-font text-gray-500 tracking-widest uppercase" for="grid-first-name">
        Title
      </label>
      <input class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" id="grid-first-name" type="text" value={title} onChange={(e) => setTitle(e.target.value)}/>
    </div>
  </div>

  <div class="flex flex-wrap -mx-3 mb-6">
    <div class="w-full px-3">
      <label class="text-xs title-font text-gray-500 tracking-widest uppercase mb-2" for="grid-first-name">
        Prompt
      </label>
      <input class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" id="grid-first-name" type="text" value={line} onChange={(e) => setLine(e.target.value)}/>
    </div>
  </div>

  <div class="flex flex-wrap -mx-3 mb-6">
    <div class="w-full px-3">
      <label class="text-xs title-font text-gray-500 tracking-widest uppercase mb-2" for="grid-first-name">
        Instruction
      </label>
      <textarea class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" id="grid-first-name" type="text" value={instruction} onChange={(e) => setInstruction(e.target.value)}/>
    </div>
  </div>

  <div class="flex flex-wrap -mx-3 mb-2">
  <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
      <label class="text-xs title-font text-gray-500 tracking-widest uppercase mb-2" for="grid-state">
        AI Art Generator
      </label>
      <div class="relative">
        <select class="block appearance-none w-full bg-gray-100 border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state" onChange={(e) => {setType(e.target.value);}}>
                {AIGenType.map((item) => (
                  <option className="text-base border-0 outline-none capitalize bg-white text-black " value={item.name}>
                    {item.name}
                  </option>
                ))}
        </select>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
        </div>
      </div>
    </div>

    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
      <label class="text-xs title-font text-gray-500 tracking-widest uppercase mb-2" for="grid-state">
        Category
      </label>
      <div class="relative">
        <select class="block appearance-none w-full bg-gray-100 border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state"  onChange={(e) => {setCategory(e.target.value);}}>
        {categories.map((item) => (
                  <option className="text-base border-0 outline-none capitalize bg-white text-black " value={item.name}>
                    {item.name}
                  </option>
                ))}
        </select>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
        </div>
      </div>
    </div>
  </div>

  {
              wrongImageType && (
                <p>It&apos;s wrong file type.</p>
              )
            }

          */

export default CreatePrompt